import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";

const AuthCtx = createContext({ user: null, setUser: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try { const r = await api.post("/auth/refresh"); setUser(r.data.user); } catch { setUser(false); }
    });
  }, []);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-10 text-sm text-ab-muted" data-testid="auth-loading">Checking session…</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return children;
};
